/*
 * N&H cart upsell controller.
 *
 * Reveals the Ritual-style interstitial (snippets/cart-upsell.liquid) ONLY after
 * an add-to-cart from a product-form. The cart drawer re-renders its whole inner
 * HTML on add, so we wait one frame (rAF) for the fresh <cart-upsell> to land,
 * then activate it. If no recommendation was rendered, nothing happens and the
 * cart simply shows. Dismissing ("Continue to cart" / close) hides it; closing
 * the drawer resets it so it never lingers over the cart on the next open.
 */
(function () {
  function titleFromCartData(data) {
    if (!data) return "";
    if (Array.isArray(data.items) && data.items.length) {
      const it = data.items[0];
      return it.product_title || it.title || "";
    }
    return data.product_title || data.title || "";
  }

  function getUpsell() {
    return document.querySelector("cart-upsell.nh-upsell");
  }

  function activate(addedTitle) {
    const el = getUpsell();
    if (!el) return; // no recommendation -> just show the cart
    if (addedTitle) {
      const label = el.querySelector("[data-upsell-added]");
      if (label) label.textContent = addedTitle + " added to cart.";
    }
    el.classList.add("is-active");
    el.scrollTop = 0;
  }

  function deactivate() {
    const el = getUpsell();
    if (el) el.classList.remove("is-active");
  }

  // Reveal after an add-to-cart (product-form only — ignore qty/remove updates).
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (payload) {
      if (!payload || payload.source !== "product-form") return;
      const addedTitle = titleFromCartData(payload.cartData);
      // Drawer re-renders synchronously after this event; show on the next frame.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          activate(addedTitle);
        });
      });
    });
  }

  // Dismiss via "Continue to cart" or the close (×).
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-upsell-dismiss]")) {
      e.preventDefault();
      deactivate();
    }
  });

  // Never let the interstitial linger over the cart once the drawer closes.
  document.addEventListener("cart-drawer-close", deactivate);
})();
